import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "arv-reactcomponents";
import { MYACCOUNTPAGE } from "npmlinks-constants";
import { withRouter } from "react-router";

const {
  MYACCOUNT: { SHOW_SUBTITLES },
} = MYACCOUNTPAGE;

@withRouter
class MyAccountAccordian extends Component {
  static isDefaultOpen(props) {
    return props.location.hash === props.hash;
  }
  constructor(props) {
    super(props);
    this.state = {
      open: MyAccountAccordian.isDefaultOpen(props) || false,
    };
    this.onAccordianClick = this.onAccordianClick.bind(this);
  }
  onAccordianClick() {
    this.setState({ open: !this.state.open });
  }
  render() {
    const {
      backgroundColor,
      iconName,
      title,
      accordionComponent,
      subtitle,
    } = this.props;
    return (
      <div className="nw-acnt-accordian-wrapper">
        <Button
          className={`nw-acnt-accordian ${backgroundColor}`}
          onClick={() => {
            this.onAccordianClick();
          }}
        >
          <div className="nw-acnt-icon-wrapper">
            <i className={`${iconName} nw-acnt-icon`} />
          </div>
          <div className="nw-acnt-content-wrapper">
            <span className="nw-acnt-title">{title}</span>
            {SHOW_SUBTITLES && (
              <span className="nw-acnt-subtitle">{subtitle}</span>
            )}
          </div>
          <div className="nw-acnt-arrow-wrapper">
            {!this.state.open && (
              <i className="icomoon-arrow_right nw-acnt-arrow" />
            )}
            {this.state.open && (
              <i className="icomoon-arrow_bottom nw-acnt-arrow" />
            )}
          </div>
        </Button>
        {this.state.open && accordionComponent}
      </div>
    );
  }
}

MyAccountAccordian.defaultProps = {
  subtitle: "",
};

MyAccountAccordian.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  accordionComponent: PropTypes.shape({}),
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: MyAccountAccordian,
  component: MyAccountAccordian,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountAccordion/index.js